"use client";

import { MotionProps, motion } from "framer-motion";

import Link from "next/link";
import React from "react";
import styles from "./Button.module.css";

type ButtonProps = React.ComponentProps<"button"> & {
  variant?: "primary" | "secondary";
  outline?: "outline" | "filled";
  className?: string;
};

export const Button = ({
  variant = "primary",
  outline = "filled",
  className,
  ...delegated
}: ButtonProps) => {
  return (
    <motion.button
      className={`${styles.button} ${styles[variant]} ${styles[outline]} ${className}`}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      {...(delegated as MotionProps)}
    >
      {delegated.children}
    </motion.button>
  );
};

type ButtonLinkProps = React.ComponentProps<"a"> & {
  variant?: "primary" | "secondary" | "primaryLink" | "secondaryLink";
  href: string;
  locale?: string;
  outline?: "outline" | "filled";
  isExternal?: boolean;
  onClick?: () => void;
};

export const ButtonLink = ({
  variant = "primary",
  href,
  outline = "filled",
  isExternal = false,
  locale,
  className,
  onClick,

  ...props
}: ButtonLinkProps) => {
  const MotionLink = motion(Link);
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (onClick) {
      onClick();
    }
  };

  return (
    <motion.div whileTap={{ scale: 0.9 }} whileHover={{ scale: 1.1 }}>
      <Link
        href={href}
        locale={locale}
        passHref
        className={`${styles.button} ${styles[variant]} ${styles[outline]} ${className}`}
        target={isExternal ? "_blank" : undefined}
        rel={isExternal ? "noopener noreferrer" : undefined}
        onClick={handleClick}
        {...props}
      />
    </motion.div>
  );
};
